import { ISearchResult } from '@models/ISearchResult';
import { Fragment } from 'react';

interface Props {
  readonly results: ISearchResult[];
  readonly suggestedSearchTitleLabel: string;
}

const SearchResultsList = ({ results, suggestedSearchTitleLabel }: Props) => {
  const displayedResults =
    results?.filter(
      (result, index) => result.title && result.url && index < 3
    ) ?? [];

  return (
    <div className="h-full" data-testid="CT-48-Search-Results-List-Container">
      <p
        className="body-three mb-8 pt-5 text-grey-500 md:pt-15"
        data-testid="CT-48-Search-Results-List-Suggested-Search-Title"
      >
        {suggestedSearchTitleLabel}
      </p>

      <div className="grid w-full max-w-[655px] grid-cols-2 items-center gap-x-10 md:grid-cols-[auto_1fr]">
        {displayedResults.map(({ pageTypeLabel, title, url }, index) => (
          <Fragment key={`search-result-${title}`}>
            <a
              href={url}
              key={`search-results-${title}-tag`}
              target="_self"
              data-testid={`CT-48-Search-Results-List-Suggested-Search-Page-Link-${index}`}
            >
              <span className="body-two inline-block max-w-full truncate whitespace-nowrap rounded-[100px] bg-black-100 pt-2 pr-4 pb-2 pl-4 text-white decoration-1 hover:underline md:w-auto md:max-w-auto">
                {pageTypeLabel}
              </span>
            </a>

            <a
              href={url}
              key={`search-results-${title}-text`}
              target="_self"
              data-testid={`CT-48-Search-Results-List-Suggested-Search-Title-${index}`}
            >
              <p className="h6 py-3 text-black-100 decoration-1 hover:underline">
                {title}
              </p>
            </a>

            {index < displayedResults.length - 1 && (
              <div className="col-span-full h-[1px] bg-grey-line" />
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default SearchResultsList;
